import {Stack, TextField} from '@mui/material';
import {useMemo, useState} from 'react';
import {ModuleTopic} from '@cp/model';
import DropdownTopic from '../../atoms/dropdownTopic/DropdownTopic';

export interface BondDropdownTopicWithFilterProps {
  value?: string | null;
  onChange: (value?: string) => void;
  availableTopics: ModuleTopic[];
  disabled?: boolean;
  label?: string;
  required?: boolean;
  id?: string;
  showDetail?: boolean;
  /** Whether to show "All Topics" option (for optional topic) */
  allowAll?: boolean;
}

export default function BondDropdownTopicWithFilter({
  value,
  onChange,
  availableTopics,
  disabled = false,
  label = 'Topic',
  required = false,
  id,
  showDetail = false,
  allowAll = false,
}: BondDropdownTopicWithFilterProps) {
  const [filterText, setFilterText] = useState('');

  const filteredTopics = useMemo(() => {
    if (!filterText.trim()) {
      return availableTopics;
    }
    const lowerFilter = filterText.toLowerCase();
    return availableTopics.filter(
      (topic) =>
        topic.category?.toLowerCase().includes(lowerFilter) ||
        topic.topic?.toLowerCase().includes(lowerFilter) ||
        topic.detail?.toLowerCase().includes(lowerFilter),
    );
  }, [availableTopics, filterText]);

  return (
    <Stack
      direction={{xs: 'column', sm: 'row'}}
      spacing={2}
      sx={{width: '100%'}}
      data-testid="bond-dropdown-topic-with-filter"
    >
      <Stack sx={{flex: 1, minWidth: 0}}>
        <DropdownTopic
          value={value}
          onChange={onChange}
          availableTopics={filteredTopics}
          disabled={disabled}
          label={label}
          required={required}
          id={id}
          showDetail={showDetail}
          allowAll={allowAll}
        />
      </Stack>
      <TextField
        label="Filter"
        value={filterText}
        onChange={(e) => setFilterText(e.target.value)}
        size="small"
        sx={{
          width: {xs: '100%', sm: 200},
          minWidth: {sm: 200},
          flexShrink: 0,
        }}
        disabled={disabled}
      />
    </Stack>
  );
}
